import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import { GET_SETTLEMENTLIST, GET_SETTLEMENTDETAILS, GET_ADDSETTLEMENT, GET_UPDATESETTLEMENT,GET_CONSOLIDATEDINVOICE } from "resources/actionTypes";
import { getSettlementDetails, getSettlementList, updateSettlement, addSettlement,getConsolidatedInvoice } from "services/SettlementService";
import { onLoaderTrigger } from 'redux/actions/commonAction';


function* fetchGetSettlementList(action) {
  const payload = action.payload || {};
  const settlementList = yield call(getSettlementList, payload);
  if (settlementList.success) {
    yield put({
      type: GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_SUCCESS,
      settlementList: settlementList,
    });
  } else {
    yield put({
      type: GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_FAILED,
      message: settlementList.message,
    });
      toast.error(settlementList?.message || "Fetching Settlement list failed");
   
  }
}

export function* getSettlementListWatcher() {
  yield takeEvery(
    GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_REQUESTED,
    fetchGetSettlementList
  );
}

function* fetchGetSettlementDetails(action) {
  const payload = action.payload || {};
  const settlementDetails = yield call(getSettlementDetails, payload);
  if (settlementDetails.success) {
    yield put({
      type: GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_SUCCESS,
      settlementDetails: settlementDetails,
    });
  } else {
    yield put({
      type: GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_FAILED,
      message: settlementDetails.message,
    });
      toast.error(settlementDetails?.message || "Fetching Settlement Details failed");
  }
}

export function* getSettlementDetailsWatcher() {
  yield takeEvery(
    GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_FAILED,
    fetchGetSettlementDetails
  );
}

function* fetchAddSettlement(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const addSettlementData = yield call(
    addSettlement,
    payload.settlementData
  );
  if (addSettlementData.success) {
    yield put({
      type: GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_SUCCESS,
      addSettlementData: addSettlementData,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.success(addSettlementData.message);
    payload.navigate('/payment');
  } else {
    yield put({
      type: GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_FAILED,
      message: addSettlementData.message,
    });
    store.dispatch(onLoaderTrigger(false));
      toast.error(addSettlementData?.message || "Adding Settlement Failed");
  }
}

export function* addSettlementWatcher() {
  yield takeEvery(
   GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_REQUESTED,
    fetchAddSettlement
  );
}

//Update Reservation
function* updateSettlementSaga(action) {
  const payload = action.payload || {};

  const updateSettlementData = yield call(updateSettlement, payload?.updateSettlement, payload?.id);
  if (updateSettlementData.success) {
    yield put({
      type: GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_SUCCESS,
      updateSettlementData: updateSettlementData,
    });
    toast.success(updateSettlementData.message || "Updated Settlement Successfully");
  } else {
    yield put({
      type: GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_FAILED,
      message: updateSettlementData.message,
    });
      toast.error(updateSettlementData.message || "Updating Settlement failed");
  }
}

export function* updateSettlementWatcher() {
  yield takeEvery(
    GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_REQUESTED,
    updateSettlementSaga
  );
}

function* fetchGetConsolidatedInvoiceList(action) {
  const payload = action.payload || {};
  const consolidatedData = yield call(getConsolidatedInvoice, payload);
  if (consolidatedData.success) {
    yield put({
      type: GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_SUCCESS,
      consolidatedData: consolidatedData,
    });
  } else {
    yield put({
      type: GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_FAILED,
      message: consolidatedData.message,
    });
      toast.error(consolidatedData.message || "Fetching Consolidated Invoice list failed");
  }
}

export function* getConsolidatedDataWatcher() {
  yield takeEvery(
   GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_REQUESTED,
    fetchGetConsolidatedInvoiceList
  );
}